import * as THREE from 'three';
import { camera } from './camera.js'
import { CSS3DRenderer, CSS3DSprite, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

const scene = new THREE.Scene();
const renderer = new THREE.WebGLRenderer({ antialias: true,powerPreference:"high-performance" });
let bigSize={
  offsetx:0.12,
  offsety:0.23,
  xyADD:1.5
}

renderer.setSize(window.innerWidth*bigSize.xyADD, window.innerHeight*bigSize.xyADD);
// renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
renderer.toneMapping=THREE.LinearToneMapping
// renderer.toneMapping = THREE.ReinhardToneMapping;
renderer.toneMappingExposure=1.2

renderer.sortObjects=false//定义渲染器是否应对对象进行排序。默认是true. 不再透明度排序，从而修补透明度 显示bug
// renderer.clippingPlanes = Empty;
// renderer.localClippingEnabled = true;

const lightA = new THREE.AmbientLight( 0xffffff ,1.1); // soft white light
// scene.add( lightA );

const light = new THREE.PointLight( 0xffffff, 1.2 );
light.position.set( -38.229, 18.740, 18.302 );
// scene.add( light );


const CSS3renderer = new CSS3DRenderer();//渲染css的htlm对象
CSS3renderer.setSize(window.innerWidth*bigSize.xyADD, window.innerHeight*bigSize.xyADD);
CSS3renderer.domElement.style.position = 'absolute'
CSS3renderer.domElement.style.top = '0px'
CSS3renderer.domElement.style.letf = '0px'
CSS3renderer.domElement.style.pointerEvents = 'none'




function onWindowResize() {

    var SCREEN_WIDTH = window.innerWidth*bigSize.xyADD;
    var SCREEN_HEIGHT = window.innerHeight*bigSize.xyADD;
    CSS3renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
    renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
    camera.aspect = SCREEN_WIDTH / SCREEN_HEIGHT;
    camera.updateProjectionMatrix();

    // console.log(SCREEN_WIDTH);
    // console.log(SCREEN_HEIGHT);

  }
  
 window.addEventListener('resize', onWindowResize);//添加窗口改变相机刷新时间



export {scene,renderer,CSS3renderer};